import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';

function BannerSlider() {
    var bannerSlider = $('.banner-slider');
    bannerSlider.owlCarousel({
        loop:true,
        items: 1,
        dots:true,
        mouseDrag:false,
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        autoplay:true,
        URLhashListener: false,
        autoplayTimeout:8000,
        autoplayHoverPause:true,
        onChanged: onChange,
        onInitialized: function() {
            if (bannerSlider.children().length == 1) {
                bannerSlider.trigger('autoplay.stop.owl');
            }
        },
        nav: false,
        lazyLoad: true,
        navContainer: '#banner-slider--buttons',
        navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="9" height="14"><path fill="#FFF" fill-rule="evenodd" d="M7.041 14a1.89 1.89 0 0 0 1.385-.59c.765-.781.765-2.048 0-2.845l-3.49-3.567 3.49-3.567c.765-.781.765-2.049 0-2.845a1.947 1.947 0 0 0-2.784 0L.765 5.583a2.007 2.007 0 0 0-.577 1.415c0 .531.202 1.047.577 1.415l4.891 4.997c.39.398.895.59 1.385.59Z"/></svg>','<svg xmlns="http://www.w3.org/2000/svg" width="9" height="14"><path fill="#FFF" fill-rule="evenodd" d="M1.959 14a1.89 1.89 0 0 1-1.385-.59c-.765-.781-.765-2.048 0-2.845l3.49-3.567-3.49-3.567c-.765-.781-.765-2.049 0-2.845a1.947 1.947 0 0 1 2.784 0l4.877 4.997c.375.383.577.884.577 1.415s-.202 1.047-.577 1.415L3.344 13.41c-.39.398-.895.59-1.385.59Z"/></svg>']
    });

    $('.owl-prev').attr('aria-label', 'Previous slide button');
    $('.owl-next').attr('aria-label', 'Next slide button');


    let buttons = document.querySelectorAll('.bannerSliderTrigger');
    Array.prototype.forEach.call(buttons, (button, i) => {
        button.addEventListener('click', () => {
            bannerSlider.trigger('to.owl.carousel', i);
        });
    });

    function onChange(event) {
        let current = event.item.index;
        let dataHash = $(event.target).find(".owl-item").eq(current).find(".banner-slider--item").attr('data-id');
        $(".banner-slider--nav-item").removeClass('banner-slider--nav-item-active');
        $("#nav-item-" + dataHash).addClass('banner-slider--nav-item-active');
        bannerSlider.trigger('stop.owl.autoplay');
        bannerSlider.trigger('play.owl.autoplay');
    }

}

export default BannerSlider;




// WEBPACK FOOTER //
// ./src/js/app/components/Banner-slider.js